import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { ApplicazioniSection as Original } from 'components/organisms'
import {
  ApplicazioniSectionFloatingSettings,
  ApplicazioniSectionSettings,
} from './ApplicazioniSectionSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getItemChildren } from 'react-pagebuilder/utils/node'
import { applicazioneCardItemParams } from '../ApplicazioneCard'
import {
  layoutDefaultProps,
  layoutItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'

export const defaultProps = {
  ...layoutDefaultProps('lg'),
  theme: 'white',
}

export const ApplicazioniSectionItemParams = (enabled, id, blockProps, children) => ({
  ...layoutItemParams(blockProps),
  pk: id,
  name: children?.[0],
  description: children?.[1],
  children: getItemChildren(enabled, children?.[2], applicazioneCardItemParams),
})

export const dynamicProps = []

export const ApplicazioniSection: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={`block-applications-swiper ${props.className}`}
      >
        <Original
          item={ApplicazioniSectionItemParams(enabled, id, blockProps, children)}
          theme={blockProps.theme}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

ApplicazioniSection.craft = withCraft({
  name: 'ApplicazioniSection',
  defaultProps: defaultProps,
  settings: ApplicazioniSectionSettings,
  floatingSettings: ApplicazioniSectionFloatingSettings,
})
